import { Role, RoleContext } from '../../../pages/admin/icontact/setting/expert/agent/agent.const';
import { showPhoneNumberInString } from '../../../common/utils/common';

export enum MergeModalType {
  Ticket = 'ticket',
  Contact = 'contact',
}

export class MergeModalConst {
  static displayColumns = type => {
    switch (type) {
      case MergeModalType.Ticket:
        return [
          {
            title: 'Mã ticket',
            key: 'display_code',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Tiêu đề',
            key: 'display_subject',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Nguồn',
            key: 'display_source',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Chuyên viên',
            key: 'display_assignee',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Trạng thái',
            key: 'display_status',
            display: true,
            allowSort: false,
            classes: '',
          },
        ];
      case MergeModalType.Contact:
        return [
          {
            title: 'Tên khách hàng',
            key: 'display_name',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Số điện thoại',
            key: 'display_phone',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Email',
            key: 'display_email',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Nguồn',
            key: 'display_source',
            display: true,
            allowSort: false,
            classes: '',
          },
        ];
    }
  };
  static getModalAction = () => {
    return [
      {
        action: 'merge',
        title: 'Hợp nhất',
        classes: 'btn-primary',
        content: `<i class="icon fa fa-compress"></i> Hợp nhất`,
        display: true,
      },
    ];
  };
  static displayCodeColumns = item => {
    return `<a class="text_link" href="javascript:void(0)">${item.code}</a>`;
  };
  static displaySubjectColumns = (item, user) => {
    return item.subject ? showPhoneNumberInString(item.subject, user) : 'Chưa xác định';
  };
  static displayAssigneeColumns = (item, agents) => {
    const agent = agents.find(agent => agent.id == item.assign_agent_id);
    return agent
      ? agent.text
      : item.assignee
        ? item.assignee.name
        : item.assign_agent
          ? item.assign_agent.name
          : 'Chưa xác định';
  };
  static displaySourceTicketColumn = item => {
    switch (item.source) {
      case 'call':
        if (item.source_detail == 'CALL_INBOUND') {
          return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
        }
        if (item.source_detail == 'CALL_OUTBOUND') {
          return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
        }
        break;
      case 'email':
        return `<i class="icon fa fa-envelope"></i>`;
      case 'web':
        switch (item.source_detail) {
          case 'facebook':
            return `<i class="icon fa fa-facebook"></i>`;
          case 'zalo':
            return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
          default:
            return `<i class="icon fa fa-comments"></i>`;
        }
      case 'hand':
        return `<i class="icon fa fa-edit"></i>`;
      case 'sms':
        return `<i class="icon fa fa-commenting-o"></i>`;
      case 'zalo':
        return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
      default:
        return 'Chưa xác định';
    }
  };
  static displayStatusColumns = item => {
    switch (item.status) {
      case 1:
      case '1':
        return `<span class="badge badge-danger mr-5">Mới</span`;
      case 2:
      case '2':
        return `<span class="badge badge-info mr-5">Đang xử lý</span`;
      case 3:
      case '3':
        return `<span class="badge badge-primary mr-5">Đã xử lý</span`;
      case 4:
      case '4':
        return `<span class="badge badge-danger mr-5">Mở lại</span`;
      case 5:
      case '5':
        return `<span class="badge badge-dark mr-5">Đã đóng</span`;
    }
  };
  static displaySourceContactColumn = item => {
    switch (item.source) {
      case 'call':
        if (item.source_detail == 'CALL_INBOUND') {
          return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
        }
        if (item.source_detail == 'CALL_OUTBOUND') {
          return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
        }
        break;
      case 'CALL_INBOUND':
        return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
      case 'CALL_OUTBOUND':
        return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
      case 'email':
        return `<i class="icon fa fa-envelope"></i>`;
      case 'web':
        return `<i class="icon fa fa-comments"></i>`;
      case 'hand':
        return `<i class="icon fa fa-edit"></i>`;
      case 'facebook':
        return `<i class="icon fa fa-facebook"></i>`;
      case 'zalo':
        return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
      default:
        return 'Chưa xác định';
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/components/modals/merge-modal/merge-modal.const.ts